import React, {useState} from 'react';
import { Link, useLocation } from 'react-router-dom';

import './style.scss';

const getCurrentClass = (path) => {
    const location = useLocation();
    const currentPath = location.pathname;
    
    if (currentPath === "/" && path == '/transfer/inventory')
        return 'current';
    else
        return currentPath == path ? 'current' : null;
}

const Sidebar = () => {
    const inventoryPath = '/transfer/inventory';
    const warehousePath = '/transfer/warehouse';
    const imagedownloadPath = '/transfer/imagedownload';
    const customerNotifiesPath = '/report/customer-notifies';

    return (
        <div>

            <div id="app-branding-container">
                <div id="agency-name">3PL Inventory Transfer</div>
                {/* <div id="app-branding">
                    <a href="/inventory/transfer"></a>
                </div> */}
            </div>

            <div id="sidebar-menu-container">
                <div className="scroll">
                    <ul>
                        <li><Link to={inventoryPath} className={getCurrentClass(inventoryPath)}>Inventory Transfer</Link></li>
                        <li><Link to={warehousePath} className={getCurrentClass(warehousePath)} >Warehouse Transfer</Link></li>
                        <li><Link to={customerNotifiesPath} className={getCurrentClass(customerNotifiesPath)} >Customer Notifies Report</Link></li>
                        {process.env.NODE_ENV != 'production' && <li><Link to={imagedownloadPath} className={getCurrentClass(imagedownloadPath)}>Image Download</Link></li>}
                    </ul>
                </div>
            </div>

            {/* Don't need to hide the sidebar */}
            {/* <div id="toggle-container">
                <div id="sidebar-toggle">
                    <a href="#" title="Toggle Sidebar"><IconArrowLeft /></a>
                </div>
            </div> */}
        </div>
    )
}

export default Sidebar